import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { ApiUrlService } from '@pryspace/shared/environments';
import { CustomerProfile, CustomerTenant, unwrapList } from './models';

@Injectable({ providedIn: 'root' })
export class CustomerService {
  private http = inject(HttpClient);
  private api = inject(ApiUrlService);

  me() {
    return firstValueFrom(this.http.get<CustomerProfile>(this.api.url('v1/customer/me/')));
  }

  updateMe(patch: Partial<CustomerProfile>) {
    return firstValueFrom(
      this.http.patch<CustomerProfile>(this.api.url('v1/customer/me/'), patch),
    );
  }

  async tenants(): Promise<CustomerTenant[]> {
    const res = await firstValueFrom(this.http.get<
      CustomerTenant[] | { results: CustomerTenant[] }
    >(this.api.url('v1/customer/tenants/')));
    return unwrapList(res);
  }
}
